<script>
import { mapState } from 'vuex'
import dictUtils from '@/utils'

export default {
  name: 'newSelect',
  data() {
    return {
      curOption: [],
      modelValue: ''
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    validate: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    filterable: {
      type: Boolean,
      default: () => false
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    collapseTags: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    defineProps: {
      type: Object,
      default: () => {
        return { key: 'name', value: 'desc' }
      }
    },
    dicKey: {
      type: String,
      default: () => ''
    },
    enumKey: {
      type: String,
      default: () => ''
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  computed: mapState({
    allDataDict: (state) => state.user.allDataDict,
    allEnumerate: (state) => state.user.allEnumerate
  }),
  watch: {
    dicKey: {
      immediate: true,
      handler(newVal) {
        this.getOptions()
      }
    },
    enumKey: {
      immediate: true,
      handler(newVal) {
        this.getOptions()
      }
    },
    options: {
      immediate: true,
      handler(newVal) {
        this.getOptions()
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.modelValue = newVal
      }
    }
  },
  methods: {
    getOptions() {
      if (this.dicKey) {
        this.curOption = dictUtils.findDictList(this.dicKey, this.allDataDict)
      } else if (this.enumKey) {
        this.curOption = dictUtils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: this.enumKey,
          allData: this.allEnumerate
        })
      } else {
        this.curOption = this.options ? JSON.parse(JSON.stringify(this.options)) : []
      }
    },
    changeOption(e) {
      console.log(e, typeof e)
      this.$emit('input', e)
      this.$emit('change', e)
    }
  }
}
</script>

<template>
  <eco-select
    v-model="modelValue"
    :validate="validate"
    :disabled="disabled"
    :filterable="filterable"
    :clearable="clearable"
    :collapse-tags="collapseTags"
    :multiple="multiple"
    :options="curOption"
    :props="defineProps"
    @change="changeOption"
  />
</template>

<style scoped></style>
